import { Injectable } from '@angular/core';
import { VaultApiService } from '@app/core/services/api/vault-api.service';
import { AppState } from '@app/state';
import { selectAuthState } from '@app/state/auth/auth.selectors';
import { AuthState } from '@app/state/auth/auth.state';
import { ApiResponse } from '@interfaces/common/apiResponse';
import { AttachmentType } from '@interfaces/common/attachmentType';
import { TablePagination } from '@interfaces/common/pagination';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AttachmentTypeService {
  private destroy$ = new Subject<void>();
  private currentAuthState: AuthState | null = null;

  constructor(
    private store: Store<AppState>,
    private apiService: VaultApiService
  ) {
    this.store
      .select(selectAuthState)
      .pipe(takeUntil(this.destroy$))
      .subscribe((authState: AuthState) => {
        this.currentAuthState = authState;
      });
  }

  getAttachmentTypesList(
    pagination?: TablePagination,
    filter?: string
  ): Observable<ApiResponse<AttachmentType[]> | null> {
    let path = `attachment-types`;

    if (pagination) {
      path = `${path}?`;
    }

    if (pagination?.Page) {
      path = `${path}&Page=${pagination.Page}`;
    }

    if (pagination?.PageSize) {
      path = `${path}&PageSize=${pagination.PageSize}`;
    }

    if (filter) {
      path = `${path}&Filter=${filter}`;
    }

    return this.apiService.get<ApiResponse<AttachmentType[]>>(path);
  }

  getAttachmentTypeById(id: string): Observable<AttachmentType | null> {
    return this.apiService.get<AttachmentType>(`attachment-types/${id}`);
  }

  postAttachmentType(
    attachmentType: AttachmentType
  ): Observable<ApiResponse<AttachmentType> | null> {
    return this.apiService.post<ApiResponse<AttachmentType>>('attachment-types', attachmentType);
  }

  putAttachmentType(
    attachmentType: AttachmentType,
    id: string
  ): Observable<ApiResponse<AttachmentType> | null> {
    return this.apiService.put<ApiResponse<AttachmentType>>(
      `attachment-types/${id}`,
      attachmentType
    );
  }

  deleteAttachmentType(id: string): Observable<AttachmentType | null> {
    return this.apiService.delete<AttachmentType>(`attachment-types/${id}`);
  }
}
